import styled, { css } from 'styled-components';

export const Content = styled.div`
	display: flex;
	align-items: center;
	transition: all 0.4s ease-out 0s;
	gap: 4px;
`;

export const Icon = styled.span`
	display: inline-flex;
	color: ${({ theme }) => theme.colors.primary.medium};
	font-size: 20px;
`;

export const Label = styled.span`
	display: inline-flex;
	text-align: left;
	${({ theme }) => theme.typography.headlines.h6}
	color: ${({ theme }) => theme.colors.body.medium};
`;

export const Container = styled.button<{ $active: boolean }>`
	padding: 0;
	border: none;
	background: none;
	cursor: pointer;
	width: 100%;
	border-radius: 8px;
	padding: 8px;
	background-color: ${({ theme }) => theme.colors.neutral.white};

	&:hover {
		${Content} {
			transform: translateX(4px);
		}
	}

	${({ $active }) =>
		$active &&
		css`
			background-color: ${({ theme }) => theme.colors.primary.medium};

			${Label} {
				color: ${({ theme }) => theme.colors.neutral.white};
			}

			${Icon} {
				color: ${({ theme }) => theme.colors.neutral.white};
			}
		`}
`;
